import React from "react";
import { t, Trans } from "@lingui/macro";
import { TableBody, TableHeader } from "./tableData";
import { DOrdersManagementFilters } from "./filters";
import { PopupDetails } from "./popupContents/popupDetails";
import { DashboardContentPage } from "../DashboardContentTable";
import { ExclamationCircleIcon } from "@heroicons/react/outline";
import { InputSearch } from "../../../UI/InputSearch/InputSearch";
import { FiltersDashboard } from "../DashboardContentTable/FiltersDashboard";
import { DataTableDashboard } from "../DashboardContentTable/DataTableDashboard";
import { PopupPanelDashboard } from "../DashboardContentTable/PopupPanelDashboard";
import { typePaginationDashboardObject } from "../DashboardContentTable/PaginationDashboard/PaginationDashboard";

export type typeViewDataOrders = {
  variant?: string;
  searchValue: string;
  openFilterBar: boolean;
  isActiveFilters: boolean;
  onEnterSearch: () => void;
  onClearSearch: () => void;
  openPopupDetails: boolean;
  pagination?: typePaginationDashboardObject;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenFilterBar: React.Dispatch<React.SetStateAction<boolean>>;
  setIsActiveFilters: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenPopupDetails: React.Dispatch<React.SetStateAction<boolean>>;
  onChangeSearchValue: (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>,
  ) => void;
};

export const ViewComponent: React.FC<typeViewDataOrders> = ({
  variant,
  pagination,
  searchValue,
  onClearSearch,
  onEnterSearch,
  openFilterBar,
  setSidebarOpen,
  isActiveFilters,
  setOpenFilterBar,
  openPopupDetails,
  setIsActiveFilters,
  setOpenPopupDetails,
  onChangeSearchValue,
}) => {
  return (
    <DashboardContentPage
      setSidebarOpen={setSidebarOpen}
      headerTitle={<Trans>Orders</Trans>}
    >
      <FiltersDashboard
        variant={variant}
        isActiveFilters={isActiveFilters}
        filters={{
          openFilterBar: openFilterBar,
          setOpenFilterBar: setOpenFilterBar,
          filtersForm: (
            <DOrdersManagementFilters
              setOpenFilterBar={setOpenFilterBar}
              setIsActiveFilters={setIsActiveFilters}
            />
          ),
        }}
        searchBar={
          <div>
            <InputSearch
              value={searchValue}
              id="orderNumberSearch"
              onClear={onClearSearch}
              name="orderNumberSearch"
              onChange={onChangeSearchValue}
              onKeyEnterDown={onEnterSearch}
              placeholder={t`Search by order number and external order number.`}
            />
          </div>
        }
      />

      <div className="flex">
        <ExclamationCircleIcon className="w-4 h-4 mr-1 text-gray-600" />

        <p className="text-xs text-gray-500 text-center">
          <Trans>
            Enter the full order number (it consists of numbers only) or part of
            the external identification number and press “Enter”.
          </Trans>
        </p>
      </div>

      <DataTableDashboard
        pagination={pagination}
        tableHeader={<TableHeader />}
        tableBody={
          <TableBody
            variant={variant}
            setOpenPopupDetails={setOpenPopupDetails}
          />
        }
      />

      <PopupPanelDashboard
        openPopup={openPopupDetails}
        title={<Trans>Details</Trans>}
        setOpenPopup={setOpenPopupDetails}
      >
        <PopupDetails setOpenPopup={setOpenPopupDetails} />
      </PopupPanelDashboard>
    </DashboardContentPage>
  );
};
